/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_WaitInputs */

const en_shared_wait = /** @type {(inputs: Shared_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please wait…`)
};

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const de_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const es_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const fr_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const it_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const pt_br2_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const pl_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const hu_shared_wait = en_shared_wait;

/** @type {(inputs: Shared_WaitInputs) => LocalizedString} */
const ro_shared_wait = en_shared_wait;

/**
* | output |
* | --- |
* | "Please wait…" |
*
* @param {Shared_WaitInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_wait = /** @type {((inputs?: Shared_WaitInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_WaitInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_wait(inputs)
	if (locale === "de") return de_shared_wait(inputs)
	if (locale === "es") return es_shared_wait(inputs)
	if (locale === "fr") return fr_shared_wait(inputs)
	if (locale === "it") return it_shared_wait(inputs)
	if (locale === "pt-BR") return pt_br2_shared_wait(inputs)
	if (locale === "pl") return pl_shared_wait(inputs)
	if (locale === "hu") return hu_shared_wait(inputs)
	return ro_shared_wait(inputs)
});
export { shared_wait as "shared.wait" }